import {hoverDynamic} from './hover';
import {intRandom} from './_randNum';
import {shuffleArray} from './_shuffleArray';

export function bounceText() {
  const containers = document.querySelectorAll('.js-text-bounce-container');

  const is = (entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
      } else {
        entry.target.classList.remove('visible');
      }
    })
  }
  if(containers.length) {
    const observer = new IntersectionObserver(is);
    containers.forEach(c => {
      observer.observe(c);
    });
    containers.forEach(container => {
      const dataLabels = container.dataset.labels;
      if(dataLabels) {

        const isLink = container.dataset.link;
        const isViewport = (container.dataset.viewport !== undefined) ? container.dataset.viewport : false;
        const maxLabels = (container.dataset.max !== undefined) ? container.dataset.max : 50;
        const minSpeed = (container.dataset.minSpeed !== undefined) ? container.dataset.minSpeed : 0.5;
        const maxSpeed = (container.dataset.maxSpeed !== undefined) ? container.dataset.maxSpeed : 2;
        let showInterval = (container.dataset.interval !== undefined) ? container.dataset.interval : 1000;

        const labels = JSON.parse(dataLabels);
        let objects = [];
        let shuffledLabels = [];
        let currentIndex = 0;

        function createObject() {
          const label = shuffledLabels[currentIndex];
          let isReturn = false;
          if(objects.length) {
            const isExists = objects.find(e => e.label === label);
            if(isExists !== undefined) isReturn = true;
          }
          if(isReturn) return;

          const wH = window.innerHeight;
          const wW = window.innerWidth;
          const cW = container.clientWidth;
          const cH = container.clientHeight;

          let range = 0.3;
          if(wW <= 768) {
            range = 0.15;
            showInterval = showInterval*2
          }

          let centerX = ''
          let centerY = ''
          let rangeX = ''
          let rangeY = ''

          if(wH < cH && isViewport) {
            // スクロール位置を取得
            const scrollX = window.scrollX || window.pageXOffset;
            const scrollY = window.scrollY || window.pageYOffset;
            const scrollXR = scrollX + wW;
            const scrollYB = scrollY + wH;

            // コンテナの位置を取得
            const containerOffsetLeft = container.offsetLeft;
            const containerOffsetRight = containerOffsetLeft + cW;
            const containerOffsetTop = container.offsetTop;
            const containerOffsetBottom = containerOffsetTop + cH;

            // コンテナの現在のビューポートに対する位置を計算
            let winPosLeft = Math.max(containerOffsetLeft, scrollX);
            let winPosRight = Math.min(containerOffsetRight, scrollXR);
            let winPosTop = Math.max(containerOffsetTop, scrollY);
            let winPosBottom = Math.min(containerOffsetBottom, scrollYB);

            if(scrollX <= containerOffsetLeft) winPosRight = containerOffsetLeft + wW;
            if(scrollXR >= containerOffsetRight) winPosLeft = cW - wW;
            if(scrollY <= containerOffsetTop) winPosBottom = containerOffsetTop + wH;
            if(scrollYB >= containerOffsetBottom) winPosTop = cH - wH;

            // console.log(`ct:${containerOffsetTop}, cb:${containerOffsetBottom}, y:${scrollY}, yb:${scrollYB}, wpt: ${winPosTop}, wpb: ${winPosBottom}`);

            // 中心位置を計算
            centerX = (winPosLeft + winPosRight) / 2;
            centerY = (winPosTop + winPosBottom - containerOffsetTop*2) / 2;

            // 中心からの距離（20%の範囲）を計算
            rangeX = (winPosRight - winPosLeft) * range;
            rangeY = (winPosBottom - winPosTop) * range;
          } else {
            // 中心位置を計算
            centerX = cW / 2;
            centerY = cH / 2;

            // 中心からの距離（range%の範囲）を計算
            rangeX = centerX * range;
            rangeY = centerY * range;
          }

          // 最大数に達した時、古いものから消していく
          if (objects.length >= maxLabels) {
            container.removeChild(objects[0].el);
            objects.shift();
          }

          // シャッフルされた配列から順番にラベルを取得
          currentIndex = currentIndex + 1  // インデックスを更新
          if(currentIndex >= shuffledLabels.length) currentIndex = 0;
          
          let el = document.createElement('a');
          if(isLink == "false") {
            el = document.createElement('p');
          }
          el.textContent = label.label;
          el.href = label.url;
          el.classList.add('bounce-text');

          container.appendChild(el);
          const elWidth = el.clientWidth;
          
          // ラベルの位置をビューポートの中央付近に設定
          const left = centerX - elWidth/2;
          const top = (Math.random() * 2 - 1) * rangeY + centerY;
          el.style.transform = `translate(${left}px, ${top}px)`;

          if(isLink !== "false") hoverDynamic(el);

          // ランダムな背景色を追加
          const r = intRandom(120,255);
          const g = intRandom(120,255);
          const b = intRandom(120,255);
          const bgColor = `rgb(${r}, ${g}, ${b})`;
          el.style.backgroundColor = bgColor;

          // 背景色に対してコントラストのあるテキスト色を選択
          const brightness = Math.round(((r * 299) + (g * 587) + (b * 114)) / 1000);
          const textColor = (brightness > 125) ? 'black' : 'white';
          el.style.color = textColor;

          // スピードは一定にする
          const speed = Math.random() * (maxSpeed - minSpeed) + minSpeed;

          // 角度は水平または垂直を除く
          const angle = Math.random() * 2 * Math.PI;
          const dx = speed * Math.floor(Math.cos(angle));
          const dy = speed * Math.floor(Math.sin(angle));
          const obj = { label, el, dx, dy };
          objects.push(obj);
        }

        function animate() {
          for (const obj of objects) {
            const rect = obj.el.getBoundingClientRect();
            const containerRect = container.getBoundingClientRect();
            if (rect.left + obj.dx < containerRect.left || rect.right + obj.dx > containerRect.right) {
              obj.dx *= -1;
            }
            if (rect.top + obj.dy < containerRect.top || rect.bottom + obj.dy > containerRect.bottom) {
              obj.dy *= -1;
            }
            if (obj.dx === 0) obj.dx = 1;
            if (obj.dy === 0) obj.dy = 1;
            const left = (rect.left - containerRect.left) + obj.dx;
            const top = (rect.top - containerRect.top) + obj.dy;
            obj.el.style.transform = `translate(${left}px, ${top}px)`;
          }
          requestAnimationFrame(animate);
        }

        function init() {
          objects.forEach(obj => container.removeChild(obj.el));
          objects = [];
          shuffledLabels = shuffleArray(labels);
          currentIndex = 0;
          createObject();
        }
        
        setTimeout(() => {
          init();
          setInterval(() => {
            if(focus) {
              if(container.classList.contains('visible')) {
                createObject();
              } else {
                objects.forEach(obj => container.removeChild(obj.el));
                objects = [];
              }
            }
          }, showInterval);
          
          animate();
          let lastInnerWidth = window.innerWidth;
          window.addEventListener("resize", () => {
            if (lastInnerWidth != window.innerWidth) {
              init();
              lastInnerWidth = window.innerWidth;
            }
          });
  
          let focus = true;
          window.addEventListener('focus', () => {
            focus = true;
          });
          window.addEventListener('blur', () => {
            focus = false;
          });
        }, intRandom(100,2000))
      }
    })
  }
}